<template>
  <v-col cols="12">
    <v-card>
      <v-expand-transition>
        <div v-if="!buscandoPorPeriodos" class="col-12 d-flex align-center justify-center flex-wrap">
          <v-select v-model="filtros.agrupacion"
            :items="[{ text: 'Semana', value: 'semana' }, { text: 'Mes', value: 'mes' }]"
            label="Agrupar por"
            dense
            class="mx-2"
            style="min-width: 180px;"
            :disabled="loadingOEE || loadingGlobalOEE || loadingFTQ"
            @change="onAgrupacionChange"
          />

          <template v-if="filtros.agrupacion === 'semana'">
            <div class="d-flex align-center mx-2">
              <v-menu
                ref="menuDesde"
                v-model="menuDesde"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filtros.desdeSemana"
                    label="Desde (Lunes)"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :disabled="loadingOEE || loadingGlobalOEE || loadingFTQ"
                    style="min-width: 200px;"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filtros.desdeSemana"
                  :allowed-dates="soloLunes"
                  @input="menuDesde = false; onDesdeChange()"
                  no-title
                ></v-date-picker>
              </v-menu>

              <v-menu
                ref="menuHasta"
                v-model="menuHasta"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filtros.hastaSemana"
                    label="Hasta (Domingo)"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :disabled="loadingOEE || loadingGlobalOEE || loadingFTQ || !filtros.desdeSemana"
                    class="ml-2"
                    style="min-width: 200px;"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filtros.hastaSemana"
                  :allowed-dates="soloDomingos"
                  :min="filtros.desdeSemana"
                  @input="menuHasta = false"
                  no-title
                ></v-date-picker>
              </v-menu>

              <v-text-field
                v-model="horaCorte"
                label="Hora de corte"
                type="time"
                class="ml-2"
                style="max-width: 150px;"
                :disabled="loadingOEE || loadingGlobalOEE || loadingFTQ"
              />
            </div>
          </template>

          <template v-if="filtros.agrupacion === 'mes'">
            <v-autocomplete
              v-model="filtros.mesesSeleccionados"
              :items="mesesDisponibles"
              item-value="value"
              item-text="text"
              label="Meses"
              clearable
              multiple
              chips
              deletable-chips
              class="mx-2"
              style="min-width: 300px;"
              :disabled="loadingOEE || loadingGlobalOEE || loadingFTQ"
            />

            <v-select
              v-model="filtros.anio"
              :items="aniosDisponibles"
              label="Año"
              class="mx-2"
              style="min-width: 120px;"
              :disabled="loadingOEE || loadingGlobalOEE || loadingFTQ"
            />
          </template>

          <v-autocomplete
            v-model="filtros.maquinas"
            :items="instancias"
            :item-text="nombreMaquina"
            item-value="idMaquinaIns"
            label="Máquina (opcional)"
            clearable
            multiple
            chips
            dense
            class="mx-2"
            style="min-width: 400px;"
            :loading="loadingInstancias"
            :disabled="loadingOEE || loadingGlobalOEE || loadingFTQ"
          />

          <v-checkbox
            v-model="filtros.menorAMayor"
            label="Mostrar OEE crítico"
            hide-details
            class="mx-2"
            :disabled="loadingOEE || loadingGlobalOEE || loadingFTQ"
          />

          <v-btn
            color="primary"
            :disabled="!validForm"
            :loading="loadingOEE || loadingGlobalOEE || loadingFTQ || loadingTurnos"
            @click="realizarBusqueda"
            class="mx-2"
          >
            Buscar
          </v-btn>
        </div>
      </v-expand-transition>

      <v-card v-if="hayDatos" flat>
        <v-col cols="12">
          <v-col>
            <v-card-subtitle class="d-flex justify-center text-subtitle-2 align-center text--secondary">
              La información mostrada abarca el periodo
              <span class="text-subtitle-2 text--primary mx-2">{{ rangoTexto.desde }}</span>
              <span v-if="rangoTexto.hasta">hasta <span class="text-subtitle-2 text--primary mx-2">{{ rangoTexto.hasta }}</span></span>
            </v-card-subtitle>
          </v-col>

          <v-row class="mt-5">
            <v-col cols="4">
              <center>
                <Velocimetro v-if="!loadingGlobalOEE && resGlobalOEETM" v-model="resGlobalOEETM.oeePromedio" ref="oeeNYX"
                  :dataText="`OEE PROMEDIO`" suffix="%" :showText="true" size-px="370" />
                <v-progress-circular v-else indeterminate color="primary" size="370" :width="15" />
              </center>
            </v-col>
            <v-col cols="4">
              <center>
                <Velocimetro v-if="!loadingGlobalOEE && resGlobalOEETM" v-model="tmSum" :percent="resGlobalOEETM.tmPromeido" ref="tmNYX"
                  :dataText="`TIEMPO MUERTO ACUMULADO`" :showText="true" size-px="370" />
                <v-progress-circular v-else indeterminate color="primary" size="370" :width="15" />
              </center>
            </v-col>
            <v-col cols="4">
              <center>
                <Velocimetro v-if="!loadingFTQ && resGlobalFTQ" v-model="resGlobalFTQ.ftqPromedio" ref="ftqNYX" dataText="FTQ PROMEDIO"
                  suffix="%" :showText="true" size-px="370" />
                <v-progress-circular v-else indeterminate color="primary" size="370" :width="15" />
              </center>
            </v-col>

            <v-col cols="12" class="mt-5" v-if="resGlobalOEETM && resGlobalOEETM.detalles" flat>
              <v-card flat>
                <v-card-title class="d-flex justify-center align-center">
                  {{ maquinasGrafica.length }}
                  {{ filtros.menorAMayor ? 'Máquinas con OEE crítico' : 'Mejores Máquinas' }}
                </v-card-title>
                <apexchart type="bar" height="350" :options="chartOptionsPeoresMaquinas" :series="seriesPeoresMaquinas" />

                <br>

                <v-data-table :headers="headers" :items="maquinasResumen" class="elevation-1" flat>
                  <template v-slot:top>
                    <v-card-title class="text-h6 d-flex justify-center align-center" style="text-align: center; width: 100%;">
                      Resumen de Máquinas
                    </v-card-title>
                  </template>

                  <template v-slot:item.oee="{ item }">
                    <span v-if="item.sinDatos" class="grey--text font-italic">Sin datos</span>
                    <span v-else>{{ item.oee.toFixed(2) }}%</span>
                  </template>

                  <template v-slot:item.porcentajeTiempoMuerto="{ item }">
                    <span v-if="item.sinDatos" class="grey--text">--</span>
                    <span v-else>{{ item.porcentajeTiempoMuerto.toFixed(2) }}%</span>
                  </template>

                  <template v-slot:item.piezasTeoricas="{ item }">
                    {{ item.piezasTeoricas.toLocaleString('en-US', { maximumFractionDigits: 0 }) }}
                  </template>

                  <template v-slot:item.piezasReales="{ item }">
                    {{ item.piezasReales.toLocaleString('en-US', { maximumFractionDigits: 0 }) }}
                  </template>

                  <template v-slot:item.ftq="{ item }">
                    <span v-if="item.ftq !== null">{{ item.ftq.toFixed(2) }}%</span>
                    <span v-else>--</span>
                  </template>

                  <template v-slot:item.segundosAnalizados="{ item }">
                    {{ segundosAFormato(item.segundosAnalizados) }}
                  </template>

                  <template v-slot:item.segundosProductivos="{ item }">
                    {{ segundosAFormato(item.segundosProductivos) }}
                  </template>

                  <template v-slot:item.segundosMuertos="{ item }">
                    {{ segundosAFormato(item.segundosMuertos) }}
                  </template>

                  <!-- segundosParosProgAgenda -->
                  <template v-slot:item.segundosParosProgAgenda="{ item }">
                    <span v-if="item.segundosParosProgAgenda != null">
                      {{ segundosAFormato(item.segundosParosProgAgenda) }}
                    </span>
                    <span v-else>--</span>
                  </template>

                  <template v-slot:item.segundosParosProgReales="{ item }">
                    <span v-if="item.segundosParosProgReales != null">
                      {{ segundosAFormato(item.segundosParosProgReales) }}
                    </span>
                    <span v-else>--</span>
                  </template>
                </v-data-table>
                <br>

                <v-simple-table dense fixed-header class="mt-4" height="auto">
                  <thead>
                    <tr>
                      <th rowspan="3" class="text-left sticky-nombre text-subtitle-2 font-weight-bold">Nombre de la máquina</th>
                      <th rowspan="3" class="text-left sticky-lado text-subtitle-2 font-weight-bold">Lado</th>
                      <th
                        v-for="col in columnasAgrupadas"
                        :key="'col-' + col.key"
                        class="text-center"
                        colspan="2"
                        style="line-height: 1; font-size: 12px;"
                      >
                        <span class="text-subtitle-2 font-weight-bold">{{ col.label }}</span>
                      </th>
                    </tr>
                    <tr>
                      <th v-for="col in columnasAgrupadas" :key="'stats-' + col.key" colspan="2" class="text-center">
                        OEE: {{ calcularPromedioAgrupado(col.key, 'oee') }}%
                        <br>
                        TM: {{ calcularPromedioAgrupado(col.key, 'porcentajeTiempoMuerto') }}%
                      </th>
                    </tr>
                    <tr>
                      <template v-for="col in columnasAgrupadas">
                        <th :key="'sub-' + col.key + '-teo'" class="text-center">Teóricas</th>
                        <th :key="'sub-' + col.key + '-real'" class="text-center">Reales</th>
                      </template>
                    </tr>
                  </thead>

                  <tbody>
                    <template v-for="(cavidades, nombre) in maquinasConCavidadesAgrupadas">
                      <tr v-for="(gruposPorCavidad, cavidadNombre, idx) in cavidades" :key="nombre + '-' + cavidadNombre">
                        <td v-if="idx === 0" :rowspan="Object.keys(cavidades).length" class="text-left font-weight-bold sticky-nombre">
                          {{ nombre }}
                        </td>
                        <td class="text-left font-italic sticky-lado">
                          {{ cavidadNombre }}
                        </td>

                        <template v-for="col in columnasAgrupadas">
                          <td :key="nombre + '-' + cavidadNombre + '-' + col.key + '-teo'" class="text-center" style="min-width: 100px;">
                            {{
                              gruposPorCavidad[col.key] && gruposPorCavidad[col.key].piezasTeoricas != null
                                ? formatoNumero(gruposPorCavidad[col.key].piezasTeoricas)
                                : '-'
                            }}
                          </td>
                          <td :key="nombre + '-' + cavidadNombre + '-' + col.key + '-real'" class="text-center" style="min-width: 100px;">
                            {{
                              gruposPorCavidad[col.key] && gruposPorCavidad[col.key].piezasReales != null
                                ? formatoNumero(gruposPorCavidad[col.key].piezasReales)
                                : '-'
                            }}
                          </td>
                        </template>
                      </tr>
                    </template>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-col>

            <v-col cols="12" class="mt-5" flat>
              <v-card v-if="resTurnos != null && resTurnos.detalles" flat>
                <v-card-title class="d-flex justify-center align-center">
                  Datos por turnos
                </v-card-title>
                <br>
                <apexchart type="bar" height="500" :options="chartOptionsTurnos" :series="chartSeriesTurnos" />
                <br>
                <v-data-table :headers="headersTurnos" :items="maquinasFiltradas" class="elevation-1" flat>
                  <template v-slot:top>
                    <v-card flat>
                      <v-col cols="12">
                        <v-row no-gutters align="center">
                          <v-col cols="6" class="pr-2">
                            <v-autocomplete v-model="filtroTMaquinas" :items="maquinasUnicas" item-text="nombre"
                              item-value="id" label="Filtrar por Máquina" clearable multiple />
                          </v-col>
                          <v-col cols="6" class="pl-2">
                            <v-autocomplete v-model="filtroTTurnos" :items="turnosUnicos" item-text="nombre"
                              item-value="id" label="Filtrar por Turno" clearable multiple />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-card>
                  </template>

                  <template v-slot:item.nombreMaquina="{ item }">
                    {{ item.nombreMaquina }}
                  </template>

                  <template v-slot:item.nombreTurno="{ item }">
                    {{ item.nombreTurno }}
                  </template>

                  <template v-slot:item.piezasTeoricas="{ item }">
                    <span v-if="item.piezasTeoricas != null">
                      {{ item.piezasTeoricas.toLocaleString('en-US', { maximumFractionDigits: 0 }) }}
                    </span>
                    <span v-else>--</span>
                  </template>

                  <template v-slot:item.piezasReales="{ item }">
                    <span v-if="item.piezasReales != null">
                      {{ item.piezasReales.toLocaleString('en-US', { maximumFractionDigits: 0 }) }}
                    </span>
                    <span v-else>--</span>
                  </template>

                  <template v-slot:item.oee="{ item }">
                    <span v-if="item.sinDatos" class="grey--text font-italic">Sin datos</span>
                    <span v-else-if="item.oee != null">
                      {{ item.oee.toFixed(2) }}%
                    </span>
                    <span v-else>--</span>
                  </template>

                  <template v-slot:item.tiempoMuerto="{ item }">
                    <span v-if="item.tiempoMuerto != null">
                      {{ segundosAFormato(item.tiempoMuerto) }}
                    </span>
                    <span v-else>--</span>
                  </template>
                </v-data-table>
              </v-card>
              <v-card v-else-if="loadingTurnos" flat class="d-flex align-center justify-center" style="min-height: 200px;">
                <v-col cols="12" class="d-flex flex-column align-center justify-center text-center">
                  <v-progress-circular :size="70" :width="7" color="purple" indeterminate class="mb-4" />
                  <v-card-text>
                    Buscando datos por turnos
                  </v-card-text>
                </v-col>
              </v-card>
            </v-col>

            <!-- 6. OEE por Semana/Mes -->
            <v-col cols="12" class="mt-5" v-if="datosAgrupadosOEE.length > 0 || loadingOEETMDiaADia" flat>
              <v-card v-if="datosAgrupadosOEE.length > 0" flat>
                <v-card-title class="d-flex justify-center align-center">
                  OEE por {{ filtros.agrupacion === 'semana' ? 'Semana' : 'Mes' }}
                </v-card-title>
                <v-card-subtitle class="d-flex justify-center align-center error-text" v-if="filtros.agrupacion === 'semana'">
                  Los grupos consideran semanas de lunes a domingo
                </v-card-subtitle>
                <br>
                <apexchart type="bar" height="550" :options="oeeOptionsPorPeriodo" :series="oeeSeriesPorPeriodo" />
              </v-card>
              <v-card v-else-if="loadingOEETMDiaADia" flat class="d-flex align-center justify-center" style="min-height: 200px;">
                <v-col cols="12" class="d-flex flex-column align-center justify-center text-center">
                  <v-progress-circular :size="70" :width="7" color="purple" indeterminate class="mb-4" />
                  <v-card-text>Buscando datos de OEE agrupado</v-card-text>
                </v-col>
              </v-card>
            </v-col>

            <!-- 7. Tiempo Muerto por Semana/Mes -->
            <v-col cols="12" class="mt-5" v-if="datosAgrupadosOEE.length > 0 || loadingOEETMDiaADia" flat>
              <v-card v-if="datosAgrupadosOEE.length > 0" flat>
                <v-card-title class="d-flex justify-center align-center">
                  Tiempo Muerto por {{ filtros.agrupacion === 'semana' ? 'Semana' : 'Mes' }}
                </v-card-title>
                <v-card-subtitle class="d-flex justify-center align-center error-text" v-if="filtros.agrupacion === 'semana'">
                  Los grupos consideran semanas de lunes a domingo
                </v-card-subtitle>
                <br>
                <apexchart type="bar" height="550" :options="tmOptionsPorPeriodo" :series="tmSeriesPorPeriodo" />
              </v-card>
              <v-card v-else-if="loadingOEETMDiaADia" flat class="d-flex align-center justify-center" style="min-height: 200px;">
                <v-col cols="12" class="d-flex flex-column align-center justify-center text-center">
                  <v-progress-circular :size="70" :width="7" color="purple" indeterminate class="mb-4" />
                  <v-card-text>Buscando datos de Tiempo Muerto agrupado</v-card-text>
                </v-col>
              </v-card>
            </v-col>

            <!-- 8. FTQ por Semana/Mes -->
            <v-col cols="12" class="mt-5" v-if="datosAgrupadosFTQ.length > 0 || loadingFTQDiaADia" flat>
              <v-card v-if="datosAgrupadosFTQ.length > 0" flat>
                <v-card-title class="d-flex justify-center align-center">
                  FTQ por {{ filtros.agrupacion === 'semana' ? 'Semana' : 'Mes' }}
                </v-card-title>
                <v-card-subtitle class="d-flex justify-center align-center error-text" v-if="filtros.agrupacion === 'semana'">
                  Los grupos consideran semanas de lunes a domingo
                </v-card-subtitle>
                <br>
                <apexchart type="bar" height="550" :options="ftqOptionsPorPeriodo" :series="ftqSeriesPorPeriodo" />
              </v-card>
              <v-card v-else-if="loadingFTQDiaADia" flat class="d-flex align-center justify-center" style="min-height: 200px;">
                <v-col cols="12" class="d-flex flex-column align-center justify-center text-center">
                  <v-progress-circular :size="70" :width="7" color="purple" indeterminate class="mb-4" />
                  <v-card-text>Buscando datos de FTQ agrupado</v-card-text>
                </v-col>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-card>

      <v-card v-else-if="loadingGlobalOEE" flat class="d-flex align-center justify-center" style="min-height: 200px;">
        <v-col cols="12" class="d-flex flex-column align-center justify-center text-center">
          <v-progress-circular :size="70" :width="7" color="purple" indeterminate class="mb-4" />
          <v-card-text>Buscando datos</v-card-text>
        </v-col>
      </v-card>

      <v-card v-else>
        <v-col class="d-flex flex-column align-center justify-center text-center">
          <v-card-text>
            Realiza una consulta con parámetros válidos para obtener la información.
          </v-card-text>
        </v-col>
      </v-card>
    </v-card>
  </v-col>
</template>

<script>
import axios from 'axios';
import Velocimetro from '../../Velocimetro.vue';

export default {
  components: {
    Velocimetro
  },
  data() {
    const yearActual = new Date().getFullYear();
    return {
      instancias: [],
      filtros: {
        agrupacion: 'semana',
        desdeSemana: null,
        hastaSemana: null,
        mesesSeleccionados: [],
        anio: yearActual,
        maquinas: [],
        menorAMayor: true,
      },
      
      menuDesde: false,
      menuHasta: false,
      
      mesesDisponibles: [
        { value: 1, text: 'Enero' },
        { value: 2, text: 'Febrero' },
        { value: 3, text: 'Marzo' },
        { value: 4, text: 'Abril' },
        { value: 5, text: 'Mayo' },
        { value: 6, text: 'Junio' },
        { value: 7, text: 'Julio' },
        { value: 8, text: 'Agosto' },
        { value: 9, text: 'Septiembre' },
        { value: 10, text: 'Octubre' },
        { value: 11, text: 'Noviembre' },
        { value: 12, text: 'Diciembre' }
      ],
      aniosDisponibles: [yearActual - 2, yearActual - 1, yearActual],
      
      horaCorte: "07:00",
      maxMaquinas: 5,
      
      loadingInstancias: false,
      loadingOEE: false,
      loadingGlobalOEE: false,
      loadingFTQ: false,
      loadingTurnos: false,
      loadingOEETMDiaADia: false,
      loadingFTQDiaADia: false,
      buscandoPorPeriodos: false,
      
      resGlobalOEETM: null,
      resGlobalFTQ: null,
      resTurnos: null,
      resOEETMDiaADia: null,
      resFTQDiaADia: null,
      
      filtroTMaquinas: [],
      filtroTTurnos: [],
      
      headers: [
        { text: "Máquina", value: "nombre", align: "center" },
        { text: "OEE", value: "oee", align: "center" },
        { text: "Pzas Teóricas", value: "piezasTeoricas", align: "center" },
        { text: "Pzas Reales", value: "piezasReales", align: "center" },
        { text: "FTQ", value: "ftq", align: "center" },
        { text: "Analizado", value: "segundosAnalizados", align: "center" },
        { text: "Productivo", value: "segundosProductivos", align: "center" },
        { text: "Paro Calendarizado", value: "segundosParosProgAgenda", align: "center" },
        { text: "Paro Programado", value: "segundosParosProgReales", align: "center" },
        { text: "Muerto", value: "segundosMuertos", align: "center" },
      ],
      headersTurnos: [
        { text: "Máquina", value: "nombreMaquina", align: "center" },
        { text: "Turno", value: "nombreTurno", align: "center" },
        { text: "Pzas Teóricas", value: "piezasTeoricas", align: "center" },
        { text: "Pzas Reales", value: "piezasReales", align: "center" },
        { text: "OEE", value: "oee", align: "center" },
        { text: "Tiempo Muerto", value: "tiempoMuerto", align: "center" }
      ],
      
      palette: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0'],
    }
  },
  
  methods: {
    nombreMaquina: (maquina) => `[${maquina.nombre}] - ${maquina.marca} ${maquina.modelo}`,
    
    initialice() {
      this.getInstancias();
    },
    onAgrupacionChange() {
      this.filtros.desdeSemana = null;
      this.filtros.hastaSemana = null;
      this.filtros.mesesSeleccionados = [];
    },
    soloLunes(fecha) {
      if (!fecha) return false;
      const [y, m, d] = fecha.split('-').map(Number);
      const date = new Date(y, m - 1, d); // <-- crea fecha local, no UTC
      return date.getDay() === 1; // 1 = lunes
    },
    soloDomingos(fecha) {
      if (!fecha) return false;
      const [y, m, d] = fecha.split('-').map(Number);
      const date = new Date(y, m - 1, d); // <-- crea fecha local, no UTC
      return date.getDay() === 0; // 0 = domingo
    },
    onDesdeChange() {
      if (this.filtros.desdeSemana) {
        const lunes = new Date(this.filtros.desdeSemana);
        const domingo = new Date(lunes);
        domingo.setDate(lunes.getDate() + 6);
        this.filtros.hastaSemana = domingo.toISOString().split('T')[0];
      }
    }, 
    calcularRangoFechas() {
      if (this.filtros.agrupacion === 'semana') {
        if (!this.filtros.desdeSemana || !this.filtros.hastaSemana) {
          return { desde: null, hasta: null };
        }

        const desde = `${this.filtros.desdeSemana} ${this.horaCorte}:00`;
        // Ahora el domingo será el fin real de la semana (23:59:59)
        const hasta = `${this.filtros.hastaSemana} 23:59:59`;

        return { desde, hasta };
      }

      if (this.filtros.agrupacion === 'mes') {
        if (!this.filtros.mesesSeleccionados.length) {
          return { desde: null, hasta: null };
        }

        const mesesOrdenados = [...this.filtros.mesesSeleccionados].sort((a, b) => a - b);
        const primerMes = mesesOrdenados[0];
        const ultimoMes = mesesOrdenados[mesesOrdenados.length - 1];

        const desde = `${this.filtros.anio}-${String(primerMes).padStart(2, '0')}-01 ${this.horaCorte}:00`;
        const ultimoDia = new Date(this.filtros.anio, ultimoMes, 0).getDate();
        const hasta = `${this.filtros.anio}-${String(ultimoMes).padStart(2, '0')}-${ultimoDia} 23:59:59`;

        return { desde, hasta };
      }

      return { desde: null, hasta: null };
    },
    obtenerClaveGrupo(fechaISO) {
      const fecha = new Date(fechaISO);

      if (this.filtros.agrupacion === 'mes') {
        const year = fecha.getFullYear();
        const month = String(fecha.getMonth() + 1).padStart(2, '0');
        return `${year}-${month}`;
      }

      if (this.filtros.agrupacion === 'semana') {
        const day = fecha.getDay();
        const diffToMonday = (day === 0 ? -6 : 1 - day);
        const monday = new Date(fecha);
        monday.setDate(fecha.getDate() + diffToMonday);

        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);

        const formato = d => d.toISOString().split('T')[0];
        return `${formato(monday)}_${formato(sunday)}`;
      }

      return fechaISO.split('T')[0];
    },

    obtenerEtiquetaGrupo(clave) {
      if (this.filtros.agrupacion === 'mes') {
        const [year, month] = clave.split('-');
        const fecha = new Date(year, month - 1, 1);
        return fecha.toLocaleDateString('es-ES', { month: 'long', year: 'numeric' });
      }

      if (this.filtros.agrupacion === 'semana') {
        const [desde, hasta] = clave.split('_');
        const d = new Date(desde);
        const h = new Date(hasta);
        const fmt = f => f.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit' });
        return `(${fmt(d)} - ${fmt(h)})`;
      }

      return clave;
    },
    agruparDatos(datos, campoFecha = 'inicio') {
      if (!datos || !datos.length) return [];
      
      const grupos = {};
      
      datos.forEach(item => {
        const fecha = item[campoFecha] || item.fecha || item.Fecha;
        const clave = this.obtenerClaveGrupo(fecha);
        
        if (!grupos[clave]) {
          grupos[clave] = {
            clave,
            etiqueta: this.obtenerEtiquetaGrupo(clave),
            items: []
          };
        }
        
        grupos[clave].items.push(item);
      });
      
      return Object.values(grupos).sort((a, b) => a.clave.localeCompare(b.clave));
    },
    getInstancias() {
      this.loadingInstancias = true;
      axios
        .get("/MaquinaInstancias")
        .then(response => this.instancias = response.data)
        .catch(error => console.log(error))
        .finally(() => this.loadingInstancias = false);
    },

    getResumenOeeAvanzado(desde, hasta) {
      this.resGlobalOEETM = null;
      this.resTurnos = null;
      this.resOEETMDiaADia = null;
      this.resGlobalFTQ = null;
      this.resFTQDiaADia = null;

      this.loadingGlobalOEE = true;
      this.loadingTurnos = true;
      this.loadingOEETMDiaADia = true;
      this.loadingFTQ = true;
      this.loadingFTQDiaADia = true;

      const desdeQS = encodeURIComponent(desde);
      const hastaQS = encodeURIComponent(hasta);
      const horaCorteQS = encodeURIComponent(this.horaCorte || '00:00');
      const maquinas = this.filtros.maquinas || [];
      const idsQS = maquinas.map(id => `idMaquinas=${encodeURIComponent(id)}`).join('&');

      let url = `/Reportes/ObtenerResumenOEEAvanzadoNyx?desde=${desdeQS}&hasta=${hastaQS}&horaCorte=${horaCorteQS}`;
      if (idsQS) {
        url += `&${idsQS}`;
      }

      axios
        .get(url)
        .then(response => {
          const data = response.data || {};
          this.resGlobalOEETM = data.oeeTm || null;
          this.resTurnos = data.oeeTurnos || null;
          this.resOEETMDiaADia = data.oeeTmPorDia || null;
          this.resGlobalFTQ = data.ftq || null;
          this.resFTQDiaADia = data.ftqPorDia || null;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loadingGlobalOEE = false;
          this.loadingTurnos = false;
          this.loadingOEETMDiaADia = false;
          this.loadingFTQ = false;
          this.loadingFTQDiaADia = false;
        });
    },
    
    getOEETM(desde, hasta) {
      this.resGlobalOEETM = null;
      this.loadingGlobalOEE = true;

      const desdeQS = encodeURIComponent(desde);
      const hastaQS = encodeURIComponent(hasta);
      const maquinas = this.filtros.maquinas || [];
      const idsQS = maquinas.map(id => `idMaquinas=${encodeURIComponent(id)}`).join('&');

      axios
        .get(`/Reportes/ObtenerResumenOEETMNyx?desde=${desdeQS}&hasta=${hastaQS}` + (idsQS ? `&${idsQS}` : ''))
        .then(response => this.resGlobalOEETM = response.data)
        .catch(error => console.log(error))
        .finally(() => this.loadingGlobalOEE = false);
    },
    
    getFTQ(desde, hasta) {
      this.resGlobalFTQ = null;
      this.loadingFTQ = true;

      const desdeQS = encodeURIComponent(desde);
      const hastaQS = encodeURIComponent(hasta);
      const maquinas = this.filtros.maquinas || [];
      const idsQS = maquinas.map(id => `idMaquinas=${encodeURIComponent(id)}`).join('&');

      axios
        .get(`/Reportes/ObtenerResumenFTQNyx?desde=${desdeQS}&hasta=${hastaQS}` + (idsQS ? `&${idsQS}` : ''))
        .then(response => this.resGlobalFTQ = response.data)
        .catch(error => console.log(error))
        .finally(() => this.loadingFTQ = false);
    },
    
    getDatosTurnos(desde, hasta) {
      this.resTurnos = null;
      this.loadingTurnos = true;

      const desdeQS = encodeURIComponent(desde);
      const hastaQS = encodeURIComponent(hasta);
      const maquinas = this.filtros.maquinas || [];
      const idsQS = maquinas.map(id => `idMaquinas=${encodeURIComponent(id)}`).join('&');

      axios
        .get(`/Reportes/ObtenerResumenOEETurnosNyx?desde=${desdeQS}&hasta=${hastaQS}` + (idsQS ? `&${idsQS}` : ''))
        .then(response => this.resTurnos = response.data)
        .catch(error => console.log(error))
        .finally(() => this.loadingTurnos = false);
    },
    
    getOEETMDiaADia(desde, hasta) {
      this.resOEETMDiaADia = null;
      this.loadingOEETMDiaADia = true;

      const desdeQS = encodeURIComponent(desde);
      const hastaQS = encodeURIComponent(hasta);
      const horaCorteQS = encodeURIComponent(this.horaCorte || '00:00');
      const maquinas = this.filtros.maquinas || [];
      const idsQS = maquinas.map(id => `idMaquinas=${encodeURIComponent(id)}`).join('&');

      axios
        .get(`/Reportes/ObtenerResumenOEETMDiasLogicosNyx?desde=${desdeQS}&hasta=${hastaQS}&horaCorte=${horaCorteQS}` + (idsQS ? `&${idsQS}` : ''))
        .then(response => this.resOEETMDiaADia = response.data)
        .catch(error => console.log(error))
        .finally(() => this.loadingOEETMDiaADia = false);
    },
    
    getFTQDiaADia(desde, hasta) {
      this.resFTQDiaADia = null;
      this.loadingFTQDiaADia = true;

      const desdeQS = encodeURIComponent(desde);
      const hastaQS = encodeURIComponent(hasta);
      const horaCorteQS = encodeURIComponent(this.horaCorte || '00:00');
      const maquinas = this.filtros.maquinas || [];
      const idsQS = maquinas.map(id => `idMaquinas=${encodeURIComponent(id)}`).join('&');

      axios
        .get(`/Reportes/ObtenerFTQPorDiaLogicoNyx?desde=${desdeQS}&hasta=${hastaQS}&horaCorte=${horaCorteQS}` + (idsQS ? `&${idsQS}` : ''))
        .then(response => this.resFTQDiaADia = response.data)
        .catch(error => console.log(error))
        .finally(() => this.loadingFTQDiaADia = false);
    },
    async realizarBusqueda() {
      const rango = this.calcularRangoFechas();
      if (!rango.desde || !rango.hasta) return;

      this.filtroTMaquinas = [];
      this.filtroTTurnos = [];
      
      const pad = n => String(n).padStart(2, '0');
      const now = new Date();
      const hDate = new Date(rango.hasta.replace(' ', 'T'));
      const hastaFinal = hDate > now
        ? `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}`
        : rango.hasta;

      // Peticiones en paralelo en lugar de la combinada (que corre 5 consultas
      // pesadas en secuencia y bloquea toda la vista). Cada sección prende/apaga
      // su propio loading y se pinta en cuanto llega -> la info aparece por partes.
      this.getOEETM(rango.desde, hastaFinal);
      this.getFTQ(rango.desde, hastaFinal);
      this.getDatosTurnos(rango.desde, hastaFinal);
      this.getOEETMDiaADia(rango.desde, hastaFinal);
      this.getFTQDiaADia(rango.desde, hastaFinal);
    },

    segundosAFormato(segundos) {
      const totalSegundos = Math.round(segundos);

      const dias = Math.floor(totalSegundos / 86400);
      const horas = Math.floor((totalSegundos % 86400) / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundosRestantes = totalSegundos % 60;

      const formatoHoras = String(horas).padStart(2, '0');
      const formatoMinutos = String(minutos).padStart(2, '0');
      const formatoSegundos = String(segundosRestantes).padStart(2, '0');

      return dias > 0
        ? `${dias}d ${formatoHoras}:${formatoMinutos}:${formatoSegundos}`
        : `${formatoHoras}:${formatoMinutos}:${formatoSegundos}`;
    },
    
    formatoNumero(valor, decimales = 0) {
      const num = Number(valor);
      if (isNaN(num)) return "-";

      return new Intl.NumberFormat("es-MX", {
        minimumFractionDigits: decimales,
        maximumFractionDigits: decimales
      }).format(num);
    },
    
    calcularPromedioAgrupado(claveGrupo, campo) {
      const datos = this.resGlobalOEETM?.detallesPorDias || [];
      if (!datos.length) return "0.00";
      
      const filtrados = datos.filter(d => {
        const claveItem = this.obtenerClaveGrupo(d.inicio);
        return claveItem === claveGrupo;
      });
      
      if (!filtrados.length) return "0.00";
      
      const suma = filtrados.reduce((acc, cur) => acc + (cur[campo] ?? 0), 0);
      return (suma / filtrados.length).toFixed(2);
    },
  },
  
  mounted() {
    this.initialice();
  },
  
  computed: {
    validForm() {
      if (this.filtros.agrupacion === 'semana') {
        return !!(this.filtros.desdeSemana && this.filtros.hastaSemana);
      }
      if (this.filtros.agrupacion === 'mes') {
        return this.filtros.mesesSeleccionados.length > 0;
      }
      return false;
    },
    
    hayDatos() {
      // Mostrar el contenedor apenas empieza cualquier carga o llega cualquier
      // sección, para que aparezcan los spinners por sección y la info se pinte
      // por partes en vez de esperar a que termine la consulta más lenta.
      return this.resGlobalOEETM != null || this.resGlobalFTQ != null || this.resTurnos != null
        || this.loadingGlobalOEE || this.loadingFTQ || this.loadingTurnos
        || this.loadingOEETMDiaADia || this.loadingFTQDiaADia;
    },
    
    fechaDesdeFormateada() {
      if (!this.filtros.desdeSemana) return '';
      const fecha = new Date(this.filtros.desdeSemana);
      return fecha.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
    },
    
    fechaHastaFormateada() {
      if (!this.filtros.hastaSemana) return '';
      const fecha = new Date(this.filtros.hastaSemana);
      return fecha.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
    },
    
    rangoTexto() {
      const rango = this.calcularRangoFechas();
      if (!rango.desde || !rango.hasta) {
        return { desde: '-', hasta: '-' };
      }
      
      if (this.filtros.agrupacion === 'semana') {
        return {
          desde: this.filtros.desdeSemana,
          hasta: this.filtros.hastaSemana
        };
      }
      
      if (this.filtros.agrupacion === 'mes') {
        const mesesTexto = this.filtros.mesesSeleccionados
          .sort((a, b) => a - b)
          .map(m => this.mesesDisponibles.find(mes => mes.value === m)?.text)
          .join(', ');
        return {
          desde: `${mesesTexto} ${this.filtros.anio}`,
          hasta: ''
        };
      }
      
      return { desde: '-', hasta: '-' };
    },
    
    maquinasGrafica() {
      // Excluir máquinas "sin datos" (sin actividad) para que no aparezcan como 0% en la gráfica.
      const maquinas = (this.resGlobalOEETM?.detalles ?? []).filter(m => !m.sinDatos);
      const primeras = maquinas.length > this.maxMaquinas ? maquinas.slice(0, this.maxMaquinas) : maquinas;
      return primeras;
    },
    
    chartOptionsPeoresMaquinas() {
      const maquinas = this.maquinasGrafica;
      return {
        chart: {
          height: 350,
          type: 'bar',
        },
        legend: { show: false },
        plotOptions: {
          bar: {
            distributed: true,
            borderRadius: 10,
            dataLabels: { position: 'top' },
          }
        },
        colors: maquinas.map((_, i) => this.palette[i % this.palette.length]),
        dataLabels: {
          enabled: true,
          formatter: val => val + '%',
          offsetY: -20,
          style: { fontSize: '12px', colors: ['#304758'] }
        },
        xaxis: {
          categories: maquinas.map(m => m.nombre),
          position: 'top',
          axisBorder: { show: false },
          axisTicks: { show: false },
          crosshairs: {
            fill: {
              type: 'gradient',
              gradient: {
                colorFrom: '#D8E3F0',
                colorTo: '#BED1E6',
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              }
            }
          },
          tooltip: { enabled: true }
        },
        yaxis: {
          axisBorder: { show: false },
          axisTicks: { show: false },
          labels: { show: false, formatter: val => val + '%' }
        },
      }
    },
    
    seriesPeoresMaquinas() {
      const maquinas = this.maquinasGrafica;
      return [{
        name: 'OEE',
        data: maquinas.map(m => m.oee.toFixed(2))
      }];
    },
    
    maquinasResumen() {
      const ftqMap = (this.resGlobalFTQ?.detalles || []).reduce((acc, item) => {
        acc[item.idMaquinaIns] = item.ftq;
        return acc;
      }, {});

      return (this.resGlobalOEETM?.detalles || []).map(item => ({
        ...item,
        ftq: ftqMap[item.idMaquinaIns] ?? null
      }));
    },
    
    columnasAgrupadas() {
      const datos = this.resGlobalOEETM?.detallesPorDias || [];
      if (!datos.length) return [];

      const grupos = {};
      datos.forEach(d => {
        const clave = this.obtenerClaveGrupo(d.inicio);
        if (!grupos[clave]) {
          grupos[clave] = {
            key: clave,
            label: this.obtenerEtiquetaGrupo(clave)
          };
        }
      });

      return Object.values(grupos).sort((a, b) => a.key.localeCompare(b.key));
    },
    
    maquinasConCavidadesAgrupadas() {
      const datos = this.resGlobalOEETM?.detallesPorDias || [];
      const map = {};

      for (const item of datos) {
        if (!map[item.nombre]) map[item.nombre] = {};
        const cavidad = item.cavidad;

        if (!map[item.nombre][cavidad]) map[item.nombre][cavidad] = {};
        const claveGrupo = this.obtenerClaveGrupo(item.inicio);

        if (!map[item.nombre][cavidad][claveGrupo]) {
          map[item.nombre][cavidad][claveGrupo] = {
            piezasTeoricas: 0,
            piezasReales: 0
          };
        }

        map[item.nombre][cavidad][claveGrupo].piezasTeoricas += (item.piezasTeoricas || 0);
        map[item.nombre][cavidad][claveGrupo].piezasReales += (item.piezasReales || 0);
      }

      return map;
    },
    
    tmSum() {
      const totalSegundos = this.resGlobalOEETM?.tmSumado;

      if (typeof totalSegundos !== 'number' || totalSegundos <= 0) return '0s';

      const dias = Math.floor(totalSegundos / 86400);
      const horas = Math.floor((totalSegundos % 86400) / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);

      const partes = [];
      if (dias > 0) partes.push(`${dias}D`);
      if (horas > 0) partes.push(`${horas}H`);
      if (minutos > 0) partes.push(`${minutos}M`);

      return partes.join(':');
    },
    maquinasUnicas() {
      const detalles = (this.resTurnos && Array.isArray(this.resTurnos.detalles))
        ? this.resTurnos.detalles
        : [];
      const ids = {};
      const salida = [];
      for (const item of detalles) {
        if (!ids[item.idMaquinaIns]) {
          ids[item.idMaquinaIns] = true;
          salida.push({ id: item.idMaquinaIns, nombre: item.nombreMaquina });
        }
      }
      return salida;
    },
    turnosUnicos() {
      const detalles = (this.resTurnos && Array.isArray(this.resTurnos.detalles))
        ? this.resTurnos.detalles
        : [];
      const ids = {};
      const salida = [];
      for (const item of detalles) {
        if (!ids[item.idTurno]) {
          ids[item.idTurno] = true;
          salida.push({ id: item.idTurno, nombre: item.nombreTurno });
        }
      }
      return salida;
    },
    maquinasFiltradas() {
      const detalles = (this.resTurnos && Array.isArray(this.resTurnos.detalles))
        ? this.resTurnos.detalles
        : [];
      const promedios = (this.resTurnos && Array.isArray(this.resTurnos.promedioPorTurno))
        ? this.resTurnos.promedioPorTurno
        : [];

      const sinMaq = this.filtroTMaquinas.length === 0;
      const sinTur = this.filtroTTurnos.length === 0;

      if (sinMaq && sinTur) {
        const out = [];
        for (const p of promedios) {
          let sumTeo = 0;
          let sumReal = 0;
          for (const d of detalles) {
            if (d.idTurno === p.idTurno) {
              sumTeo += d.piezasTeoricas || 0;
              sumReal += d.piezasReales || 0;
            }
          }

          out.push({
            fecha: null,
            nombreTurno: p.nombreTurno,
            nombreMaquina: 'Promedio',
            piezasTeoricas: sumTeo,
            piezasReales: sumReal,
            oee: p.oeePromedio,
            tiempoMuerto: p.tiempoMuertoPromedio,
            porcentajeTiempoMuerto: p.porcentajeTiempoMuerto
          });
        }
        return out;
      }
      if (!sinMaq) {
        const resultado = [];
        for (const it of detalles) {
          if (this.filtroTMaquinas.indexOf(it.idMaquinaIns) === -1) continue;
          if (!sinTur && this.filtroTTurnos.indexOf(it.idTurno) === -1) continue;
          resultado.push({
            fecha: it.fecha.split('T')[0],
            nombreTurno: it.nombreTurno,
            nombreMaquina: it.nombreMaquina,
            piezasTeoricas: it.piezasTeoricas,
            piezasReales: it.piezasReales,
            oee: it.oee,
            tiempoMuerto: it.tiempoMuerto,
            porcentajeTiempoMuerto: it.porcentajeTiempoMuerto,
            sinDatos: it.sinDatos
          });
        }
        return resultado;
      }
      const filt = [];
      for (const item of detalles) {
        if (sinMaq && !sinTur && this.filtroTTurnos.indexOf(item.idTurno) === -1) {
          continue;
        }
        filt.push(item);
      }
      return filt;
    },
    
    chartSeriesTurnos() {
      const items = Array.isArray(this.maquinasFiltradas) ? this.maquinasFiltradas : [];
      const seriesOEE = [], seriesTM = [];
      for (const item of items) {
        const o = item.oee;
        const p = item.porcentajeTiempoMuerto;
        // "Sin datos" => null para que la gráfica muestre hueco en vez de 0%.
        seriesOEE.push(item.sinDatos ? null : (o != null ? Number(o.toFixed(2)) : 0));
        seriesTM.push(item.sinDatos ? null : (p != null ? Number(p.toFixed(2)) : 0));
      }
      return [
        { name: 'OEE', type: 'column', data: seriesOEE },
        { name: 'Tiempo Muerto', type: 'column', data: seriesTM }
      ];
    },
    
    chartOptionsTurnos() {
      const items = Array.isArray(this.maquinasFiltradas) ? this.maquinasFiltradas : [];
      const cats = [];
      for (const item of items) {
        let fecha = item.fecha || '';
        fecha = fecha.split('T')[0];
        const turno = item.nombreTurno || '';
        cats.push(fecha + ' – ' + turno);
      }

      return {
        dataLabels: {
          enabled: true,
          offsetY: -2,
          style: { fontSize: '12px' },
          formatter: function (val) {
            return val + '%';
          }
        },
        xaxis: {
          categories: cats
        },
        yaxis: [
          { title: { text: 'OEE (%)' } },
        ],
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: function (val, opts) {
              const si = opts.seriesIndex;
              const dp = opts.dataPointIndex;
              const item = items[dp];
              if (si === 0) {
                const reales = item.piezasReales || 0;
                const teoricas = item.piezasTeoricas || 0;
                return reales + 'Pzas' + ' De ' + Math.round(teoricas) + 'Pzas';
              } else {
                const mins = item.tiempoMuerto != null
                  ? Math.round(item.tiempoMuerto / 60)
                  : 0;
                return mins + ' min';
              }
            },
            title: { formatter: function (seriesName) { return seriesName; } }
          }
        }
      };
    },
    
    datosAgrupadosOEE() {
      const base = (this.resOEETMDiaADia && Array.isArray(this.resOEETMDiaADia.promedioPorDia))
        ? this.resOEETMDiaADia.promedioPorDia
        : [];
      
      const grupos = this.agruparDatos(base, 'fecha');
      
      return grupos.map(grupo => {
        const oeePromedio = grupo.items.reduce((sum, item) => sum + (item.oeePromedio || 0), 0) / grupo.items.length;
        const tiempoMuertoTotal = grupo.items.reduce((sum, item) => sum + (item.tiempoMuertoTotal || 0), 0);
        
        return {
          ...grupo,
          oeePromedio,
          tiempoMuertoTotal
        };
      });
    },
    
    oeeSeriesPorPeriodo() {
      const data = this.datosAgrupadosOEE.map(d => 
        d.oeePromedio != null ? Number(d.oeePromedio.toFixed(2)) : 0
      );
      return [{ name: 'OEE (%)', type: 'bar', data }];
    },
    
    oeeOptionsPorPeriodo() {
      const cats = this.datosAgrupadosOEE.map(d => d.etiqueta);
      const rowH = 64;
      const height = Math.max(350, cats.length * rowH);

      return {
        chart: { type: 'bar', toolbar: { show: true }, height },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '95%',
            dataLabels: { position: 'top' }
          }
        },
        colors: this.palette[1],
        dataLabels: {
          enabled: true,
          formatter: (val) => `${val}%`,
          offsetX: 12,
          style: {
            fontSize: '16px',
            fontWeight: '600',
            colors: ['#000']
          },
          background: {
            enabled: true,
            borderRadius: 4,
            padding: 4
          }
        },
        stroke: { show: true, width: 2, colors: ['transparent'] },
        xaxis: {
          categories: cats,
          max: 100,
          labels: { style: { fontSize: '14px', fontWeight: '600' } }
        },
        yaxis: [{
          labels: { 
            style: { fontSize: '14px', fontWeight: '600' },
            maxWidth: 300
          }
        }],
        tooltip: {
          y: { formatter: (val) => `${val}%`, title: { formatter: (s) => s } }
        }
      };
    },
    
    tmSeriesPorPeriodo() {
      const data = this.datosAgrupadosOEE.map(d => Math.round((d.tiempoMuertoTotal || 0) / 60));
      return [{ name: 'Tiempo Muerto', type: 'bar', data }];
    },
    
    tmOptionsPorPeriodo() {
      const cats = this.datosAgrupadosOEE.map(d => d.etiqueta);
      const rowH = 64;
      const height = Math.max(350, cats.length * rowH);

      const mins = this.datosAgrupadosOEE.map(d => Math.round((d.tiempoMuertoTotal || 0) / 60));
      const maxMin = Math.max(0, ...mins);
      const xmax = maxMin ? Math.ceil(maxMin * 1.2) : 60;

      const toHM = (m) => {
        const h = Math.floor(m / 60);
        const mm = m % 60;
        return `${h}h ${mm}m`;
      };

      return {
        chart: { type: 'bar', toolbar: { show: true }, height },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '95%',
            dataLabels: { position: 'top' }
          }
        },
        colors: this.palette[2],
        dataLabels: {
          enabled: true,
          formatter: (val) => toHM(val),
          offsetX: 12,
          style: {
            fontSize: '16px',
            fontWeight: '600',
            colors: ['#000']
          },
          background: { enabled: true, borderRadius: 4, padding: 4 }
        },
        stroke: { show: true, width: 2, colors: ['transparent'] },
        xaxis: {
          categories: cats,
          max: xmax,
          labels: { style: { fontSize: '14px', fontWeight: '600' } }
        },
        yaxis: [{
          labels: { 
            style: { fontSize: '14px', fontWeight: '600' },
            maxWidth: 300
          }
        }],
        tooltip: {
          y: {
            formatter: (val) => toHM(val),
            title: { formatter: (s) => s }
          }
        }
      };
    },
    
    datosAgrupadosFTQ() {
      const base = (this.resFTQDiaADia && Array.isArray(this.resFTQDiaADia.promedioPorDia))
        ? this.resFTQDiaADia.promedioPorDia
        : [];
      
      const grupos = this.agruparDatos(base, 'inicio');
      
      return grupos.map(grupo => {
        const ftqPromedio = grupo.items.reduce((sum, item) => sum + (item.ftqPromedio || 0), 0) / grupo.items.length;
        
        return {
          ...grupo,
          ftqPromedio
        };
      });
    },
    
    ftqSeriesPorPeriodo() {
      const data = this.datosAgrupadosFTQ.map(d =>
        d.ftqPromedio != null ? Number(d.ftqPromedio.toFixed(2)) : 0
      );
      return [{ name: 'FTQ (%)', type: 'bar', data }];
    },
    
    ftqOptionsPorPeriodo() {
      const cats = this.datosAgrupadosFTQ.map(d => d.etiqueta);
      const rowH = 64;
      const height = Math.max(350, cats.length * rowH);

      return {
        chart: { type: 'bar', toolbar: { show: true }, height },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '95%',
            dataLabels: { position: 'top' }
          }
        },
        colors: this.palette[3],
        dataLabels: {
          enabled: true,
          formatter: (val) => `${val}%`,
          offsetX: 12,
          style: { fontSize: '16px', fontWeight: '600', colors: ['#000'] },
          background: { enabled: true, borderRadius: 4, padding: 4 }
        },
        stroke: { show: true, width: 2, colors: ['transparent'] },
        xaxis: {
          categories: cats,
          max: 100,
          labels: { style: { fontSize: '14px', fontWeight: '600' } }
        },
        yaxis: [{
          labels: { 
            style: { fontSize: '14px', fontWeight: '600' },
            maxWidth: 300
          }
        }],
        tooltip: {
          y: { formatter: (val) => `${val}%`, title: { formatter: (s) => s } }
        }
      };
    },
  },
}
</script>

<style scoped>
.sticky-nombre {
  position: sticky;
  left: 0;
  background: white;
  z-index: 300 !important;
  width: 160px;
  min-width: 160px;
  max-width: 160px;
}

.sticky-lado {
  position: sticky;
  left: 160px;
  background: white;
  z-index: 300 !important;
  width: 120px;
  min-width: 120px;
  max-width: 120px;
}

thead th {
  position: sticky;
  top: 0;
  z-index: 1 !important;
  background: #f5f5f5;
}

::v-deep .v-date-picker-table {
  background-color: white !important;
}

::v-deep .v-date-picker-table button {
  color: #333 !important;
}

::v-deep .v-date-picker-table button:not(.v-btn--active):not(.v-btn--disabled) {
  color: rgba(0, 0, 0, 0.87) !important;
}

::v-deep .v-date-picker-table .v-btn--disabled {
  color: rgba(0, 0, 0, 0.26) !important;
}

::v-deep .v-date-picker__header {
  background-color: white !important;
}
</style>
